import useBenefitDetailDialogStore from '../_metronic/store/benefitDetailDialogStore'
import {ClaimBenefitDetail, isBenefitDetailMissing} from './claimBenefitDetail'

// Returns true when the claim can be opened. Otherwise it opens the dialog and returns false, so
// the caller must not navigate.
export const ensureBenefitDetail = (
  claimDetails: ClaimBenefitDetail | null | undefined
): boolean => {
  if (!isBenefitDetailMissing(claimDetails)) return true

  useBenefitDetailDialogStore.getState().openDialog(claimDetails?.claimNumber ?? '')
  return false
}
